// @flow
import React, { useRef, useState, useEffect } from 'react';
import GooglePayButton from '@google-pay/button-react';
import { ec as EC } from 'elliptic';
import CryptoJS from 'crypto-js';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { useCreditCardValidator, images } from 'react-creditcard-validator';
import {
  Input,
  Select,
  Modal,
  Row,
  Col,
  Button,
  Checkbox,
  Radio,
  Spin,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import SimpleReactValidator from 'simple-react-validator';
import { isValidPhoneNumber, formatNumber } from 'libphonenumber-js';
import { performValidation } from './ApplePayRestClient';
import {
  cartActions,
  notificationActions,
} from '../../../store/actions';
import {
  NOTIFICATION,
} from '../../../store/actionTypes';
import {
  axiosNoAuthInstance,
  axiosAuthInstance,
  API_END_POINTS,
} from '../../../api';
import { SpH5, SpError, SpButton, SpText } from '../../../components/DesignKit';
import CloseIcon from "../../../assets/imgs/close.svg";
import CardPay from '../../../assets/cardPay.svg';
import ApplePay from '../../../assets/applePay.svg';
import GooglePay from '../../../assets/googlePay.svg';
import Back from '../../../assets/imgs/back.svg';
import { COUNTRY_PHONE_CODE, COUNTRY_CODES } from '../../../appconstants';
import getStateList from '../../../utils/stateList';

const ec = new EC('p256');

const { Option } = Select;
const { TextArea } = Input;

type Props = {
  close: Function,
  submit: Function,
  visible: Boolean,
  shopInfo: Object,
  isMobileView: Boolean,
  inVentData: Array<object>,
  isExstingCust: Function,
  updateCust: Function,
  getItemsInfo: Function,
  getUserInfo: Function,
  setNotification: Function,
  browserMode: Function,
  groupCode: Number,
  updateOrderId: Function,
  getShopInfo: Function,
  isCustomerNumberAccept: Boolean,
  inventoryGid: String;
  totalPay: Number,
  selectedAccount: Object,
  displayRecaptcha: Function,
  recaptchaToken: String,
  savedPaymentDetails: Object,
};

const PaymentPortal = (props: Props) => {
  const {
    visible,
    close,
    submit,
    shopInfo,
    isMobileView,
    inVentData,
    isExstingCust,
    updateCust,
    getItemsInfo,
    getUserInfo,
    setNotification,
    browserMode,
    groupCode,
    updateOrderId,
    getShopInfo,
    isCustomerNumberAccept,
    inventoryGid,
    totalPay,
    selectedAccount,
    displayRecaptcha,
    recaptchaToken,
    savedPaymentDetails,
  } = props;

  const APPLE_PAY_MERCHANT_ID = process.env.REACT_APP_APPLE_PAY_MERCHANT_VERIFICATION_ID;
  const [, forceUpdate] = useState();
  const [selectPaymentMethod, setSelectPaymentMethod] = useState('multiple')
  const [quantity, setQuantity] = useState(2);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [countryCode, setCountryCode] = useState('+1');
  const [phoneFormate, setPhoneFormate] = useState();
  const [phoneNumber, setPhone] = useState('');
  const [cardholderName, setCardholderName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry] = useState('');
  const [cvv, setCvv] = useState('');
  const [isCustAvailable, setIsCustAvailable] = useState(false);
  const [isWithExstUser, setIsWithExstUser] = useState(false);
  const [custNames, setCustNames] = useState('');
  const [size, setSize] = useState('single');
  const [gropId, setGroupId] = useState(groupCode ? groupCode : '');
  const [groupName, setGroupName] = useState();
  const [isGroup, setIsGroup] = useState(false);
  const [isExstingGroup, setIsExstingGroup] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const location = useLocation();
  const parsed = queryString.parse(location.search);
  const shopTable = parsed.tableGid;
  const [ipAddress, setIpAddress] = useState('');
  const [shouldWhatsAppNotify, setShouldWhatsAppNotify] = useState(true);
  const [transactionComplete, setTransactionComplete] = useState(false);
  const [collectBillingAddress, setCollectBillingAddress] = useState(false);
  const [collectShippingAddress, setCollectShippingAddress] = useState(false);
  const [statesInCountry, setstatesInCountry] = useState([]);
  const postalCodeRegex = selectedAccount.country.alpha2 === 'US' ? /^[0-9][0-9]{4}$/ : /^[1-9][0-9]{5}$/;

  const countryName = selectedAccount && selectedAccount.country && selectedAccount.country.name;
  const currency = selectedAccount && selectedAccount.currency && selectedAccount.currency.prefix;
  const [streetName, setStreetName] = useState('');
  const [cityName, setCityName] = useState('');
  const [stateName, setStateName] = useState('');
  const [zipCode, setZipCode] = useState('');

  const [streetName1, setStreetName1] = useState('');
  const [stateName1, setStateName1] = useState('');
  const [cityName1, setCityName1] = useState('');
  const [zipCode1, setZipCode1] = useState('');

  const [addressSame, setAddressSame] = useState(false);

  const [cardNumberRequired, setCardNumberRequired] = useState(false);

  const custInfo = localStorage.getItem('customer');

  const [gpaySecretValues, setGpaySecretValues] = useState(null);
  const [payment, setPayment] = useState(null);
  const [isApplePayEnabled, setIsApplePayEnabled] = useState(false);
  const [isGooglePayEnabled, setIsGooglePayEnabled] = useState(false);
  const items = [];

  const expDateValidate = (month, year) => {
    if (Number(year) > 2035) {
      return 'Expiry Date Year cannot be greater than 2035';
    }
    return;
  }

  const {
    getCardNumberProps,
    getCardImageProps,
    getCVCProps,
    getExpiryDateProps,
    meta: { erroredInputs }
  } = useCreditCardValidator({ expiryDateValidator: expDateValidate });

  const encryptData = (data, serverPublicKey, clientPrivateKey, keyId) => {
    try {
      const publicKeyBytes = atob(serverPublicKey);
      let keyDataStart = -1;
      for (let i = 0; i < publicKeyBytes.length - 4; i++) {
        if (publicKeyBytes.charCodeAt(i) === 0x03 &&
          publicKeyBytes.charCodeAt(i + 1) === 0x42 &&
          publicKeyBytes.charCodeAt(i + 2) === 0x00 &&
          publicKeyBytes.charCodeAt(i + 3) === 0x04) {
          keyDataStart = i + 4;
          break;
        }
      }
      if (keyDataStart === -1) {
        throw new Error('Could not find public key data in DER format');
      }
      const keyData = publicKeyBytes.slice(keyDataStart, keyDataStart + 64);

      if (keyData.length !== 64) {
        throw new Error(`Invalid key data length: ${keyData.length}, expected 64`);
      }
      const publicKeyHex = '04' + Array.from(keyData)
        .map(byte => byte.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('');
      const serverPubKey = ec.keyFromPublic(publicKeyHex, 'hex');
      const sharedSecret = clientPrivateKey.derive(serverPubKey.getPublic());
      const sharedSecretBytes = sharedSecret.toArray();
      const sharedSecretHex = sharedSecretBytes.map(byte =>
        (byte < 0 ? byte + 256 : byte).toString(16).padStart(2, '0')
      ).join('');
      const aesKeyHash = CryptoJS.SHA256(CryptoJS.enc.Hex.parse(sharedSecretHex));
      const aesKey = aesKeyHash.toString(CryptoJS.enc.Hex);
      const iv = CryptoJS.lib.WordArray.random(16);
      const key = CryptoJS.enc.Hex.parse(aesKey);
      const encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return {
        encryptedData: encrypted.toString(),
        keyId: keyId,
        iv: iv.toString(CryptoJS.enc.Base64),
      };
    } catch (error) {
      console.error('Error encrypting data:', error);
      throw new Error('Failed to encrypt data');
    }
  };

  const generateClientKeyPair = () => {
    const keyPair = ec.genKeyPair();
    const publicKey = keyPair.getPublic('hex');
    const privateKey = keyPair;

    return {
      publicKey,
      privateKey,
    };
  };

  const getServerEncription = async (recaptchaToken) => {
    const config = {};
    if (recaptchaToken) {
      config.headers = {
        "X-Captcha-Token": recaptchaToken,
      };
    }
    const { data: { entity } } = await axiosNoAuthInstance.post(API_END_POINTS.ENCRIPTION, {}, config);
    return entity;
  };

  const existsApplePayJsApi = () => {
    return new Promise((resolve, reject) => {
      try {
        const enabled = window.ApplePaySession && window.ApplePaySession.canMakePayments();
        resolve(enabled);
      } catch (err) {
        reject(err);
      }
    })
  }

  const isApplePayJsAvailable = () => {
    try {
      return existsApplePayJsApi()
        .then(() => {
          return window.ApplePaySession.canMakePaymentsWithActiveCard(APPLE_PAY_MERCHANT_ID)
        })
    } catch (error) {
      console.error('Error checking Apple Pay availability:', error);
      return false;
    }
  }

  const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

  const getGooglePayMerchantValues = async (accountGid) => {
    try {
      const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.GOOGLEPAY_SECRET}/${accountGid}`);
      setGpaySecretValues(entity);
    } catch (error) {
      console.error('Missing merchant details. Please contact support')
    }
  };

  const getInventoryInfo = async (gid) => {
    try {
      const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.GET_INVENTORY_LINK}/${gid}`);
      setPayment(entity);
      setIsGooglePayEnabled(entity?.account?.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
      setIsApplePayEnabled(entity?.account?.supportedPaymentTypes.includes('APPLE_PAY_US'));
      setCollectBillingAddress(entity?.account?.collectBillingAddress);
      setCollectShippingAddress(entity?.account?.collectShippingAddress);
      setName(entity?.inventoryOrder?.customer?.name);
      setEmail(entity?.inventoryOrder?.customer?.email);
      if (entity?.inventoryOrder?.customer?.billingAddress) {
        setStreetName(entity.inventoryOrder.customer.billingAddress.street);
        setCityName(entity.inventoryOrder.customer.billingAddress.city);
        setStateName(entity.inventoryOrder.customer.billingAddress.state);
        setZipCode(entity.inventoryOrder.customer.billingAddress.postalCode);
      }
      if (entity?.inventoryOrder?.customer?.shippingAddress) {
        setStreetName1(entity.inventoryOrder.customer.shippingAddress.street);
        setCityName1(entity.inventoryOrder.customer.shippingAddress.city);
        setStateName1(entity.inventoryOrder.customer.shippingAddress.state);
        setZipCode1(entity.inventoryOrder.customer.shippingAddress.postalCode);
      }
      const cntryCd = entity?.inventoryOrder?.customer?.phoneNumber?.substring(0, 2);
      const phn = entity?.inventoryOrder?.customer?.phoneNumber?.substring(2, 14);
      if (cntryCd === '+9') {
        setCountryCode(entity?.inventoryOrder?.customer?.phoneNumber?.substring(0, 3));
        setPhoneFormate(entity?.inventoryOrder?.customer?.phoneNumber?.substring(3, 15));
        setPhone(entity?.inventoryOrder?.customer?.phoneNumber?.substring(3, 15).replaceAll(' ', ''));
      } else {
        setCountryCode(cntryCd);
        setPhoneFormate(phn);
        setPhone(phn?.replaceAll(' ', ''));
      }
      getGooglePayMerchantValues(entity && entity.account && entity.account.gid);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    setstatesInCountry(getStateList(selectedAccount.country.id));
    if (inventoryGid) {
      getInventoryInfo(inventoryGid);
    }
  }, []);

  useEffect(() => {
    if (custInfo) {
      const custName = (JSON.parse(custInfo)).name;
      setCustNames(custName);
    }
  }, [custInfo]);

  useEffect(() => {
    //  getTableInfo(shopTable);
  }, [shopTable]);

  useEffect(() => {
    if (inVentData && inVentData.length !== 0) {
      setIsCustAvailable(true);
    }
  }, [inVentData]);

  const getTableInfo = async (tableGid, isParallel = false) => {
    try {
      const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.GET_SHOP_INFO}/${tableGid}`);
      getShopInfo(entity);
      if (isParallel)//true only conc
      {
        if (entity.shopTableReservation === null) {
          setInterval(getTableInfo(shopTable, true), 5000);
        } else {
          joinReservation(entity.shopTableReservation.reservationCode);
        }

      }
      return false;
    } catch (e) {
      console.error(e);
    }
  };

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      phoneNumValidation: {
        message: 'Enter valid phone number',
        rule: (val, param) => (isValidPhoneNumber(param[0])),
      },
      cust: {
        message: 'Name must be min 4 charecters',
        rule: (val) => val.length >= 4,
      },
      postalcode: {
        message: 'Please enter valid zip code',
        rule: val => (postalCodeRegex.test(val)),
      },
    },
  }));

  const onCountryCodeChange = (value) => {
    setCountryCode(value);
    const data = formatNumber(`${value}${phoneNumber}`, 'INTERNATIONAL');
    const formater = data.substr(data.indexOf(' ') + 1);
    setPhoneFormate(formater);
  };

  const onPhoneNumberChange = (e) => {
    const updatedPhone = e.currentTarget.value;
    setPhone(updatedPhone.replace(/[^0-9+]/g, ''));
    setPhoneFormate(updatedPhone.replace(/[^0-9+]/g, ''));
    setErrMsg('');
  };

  const countryCodeValidation = (e) => {
    const keyCode = (e.which) ? e.which : e.keyCode;
    if (keyCode !== 43 && keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
      e.preventDefault();
    }
  };

  simpleValidator.current.purgeFields();

  const getInventoryOrderById = async (id) => {
    const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.GET_INVENTORY_LINK}/${id}`);
    return entity;
  };

  const addInventoryOrderChargeById = async (chargeData, recaptchaToken = null) => {
    setIsDisabled(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          const encriptedData = encryptData(JSON.stringify(chargeData), values.public_key, keys.privateKey, values.key_id);
          if (encriptedData?.keyId) {
            const config = {};
            config.headers = {
              'x-enc-public-key': keys?.publicKey,
              'x-enc-key-id': encriptedData?.keyId,
              'x-enc-iv': encriptedData?.iv,
            };
            const { data: { entity } } = await axiosNoAuthInstance.post(`${API_END_POINTS.GET_INVENTORY_LINK}/${inventoryGid}/charge`, {data: encriptedData?.encryptedData}, config);
            if (entity) {
              let nextActionUrl;
              let redirectUrl;
              let returnUrl;
              if (entity && entity.paymentSession) {
                returnUrl = entity.paymentSession && entity.paymentSession.returnUrl;
              } else {
                const info = await getInventoryOrderById(inventoryGid);
                nextActionUrl = info && info.paymentSession && info.paymentSession.nextActionUrl;
                redirectUrl = entity && entity.redirectUrl;
              }
              if (nextActionUrl) {
                window.location = nextActionUrl;
                return;
              }
              setTransactionComplete(true);
              setTimeout(function () {
                const redirectUri = returnUrl ? returnUrl : redirectUrl ? redirectUrl : 'https://www.swirepay.com';
                window.location = redirectUri;
              }, 10000);
            }
          }
        }
      }
    } catch (e) {
      if (e?.response?.status === 429){
        displayRecaptcha(chargeData);
        return;
      }
      setErrMsg(e.response && e.response.data.message);
    } finally {
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    if (recaptchaToken && savedPaymentDetails) {
      addInventoryOrderChargeById(savedPaymentDetails, recaptchaToken)
    }
  }, [recaptchaToken, savedPaymentDetails]);

  const validate = (event) => {
    setPhone(phoneNumber.replace(/[^0-9+]/g, ''));
    let isValidated = false;
    let validatedCard = false;
    if (!getCardNumberProps().ref.current.value || !getExpiryDateProps().ref.current.value || !getCVCProps().ref.current.value) {
      setCardNumberRequired(true);
      validatedCard = true;
    } else if (getCardNumberProps().ref.current.value && getExpiryDateProps().ref.current.value && getCVCProps().ref.current.value) {
      setCardNumberRequired(false);
    }
    if (!erroredInputs.cardNumber && !erroredInputs.expiryDate && !erroredInputs.cvc) {
      isValidated = true;
    }
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid || !isValidated || validatedCard) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
      ip: ipAddress,
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(),
      browserUserAgent: window.navigator.userAgent
    };
    const card = {
      cardCountryCode: 'US',
      cvv: getCVCProps().ref.current.value,
      expiryMonth: getExpiryDateProps().ref.current.value.substring(0, 2),
      expiryYear: getExpiryDateProps().ref.current.value.substring(5, 7),
      name: cardholderName,
      number: getCardNumberProps().ref.current.value.replaceAll(' ', ''),
    };

    const shippingAddress = {
      city: cityName1,
      countryCode: selectedAccount.country.alpha2,
      postalCode: zipCode1,
      state: stateName1,
      street: streetName1,
    };

    const billingAddress = {
      city: cityName,
      countryCode: selectedAccount.country.alpha2,
      postalCode: zipCode,
      state: stateName,
      street: streetName,
    };

    const customer = {
      email,
      name,
      phoneNumber: `${countryCode}${phoneNumber}`,
      postalCode: null,
      shippingAddress: collectShippingAddress ? shippingAddress : null,
      Addres: null,
    };

    const paymentMethod = {
      userAgent,
      card,
      countryCode: selectedAccount.country.alpha2,
      paymentMethodBillingAddress: collectBillingAddress ? billingAddress : null,
      postalCode: zipCode,
      type: 'CARD',
    };

    const paylod = {
      paymentMethod,
      customer,
      shouldWhatsAppNotify,
    };
    addInventoryOrderChargeById(paylod);
  };

  const getCustomerGidFromPayment = () => {
    return payment && payment.customer && payment.customer.gid;
  };

  const chargeByGooglePay = async (data) => {
    const paymentMethod = {
      type: "WALLET",
      subType: "GOOGLE_PAY_US",
      googlePayUS: {
        apiVersionMinor: data?.apiVersionMinor,
        apiVersion: data?.apiVersion,
        paymentMethodDescription: data?.paymentMethodData?.description,
        paymentMethodTokenizationDataType: data?.paymentMethodData?.tokenizationData?.type,
        paymentMethodTokenizationDataToken: data?.paymentMethodData?.tokenizationData?.token,
        paymentMethodType: data?.paymentMethodData?.type,
        paymentMethodInfo: data?.paymentMethodData?.info
      },
    };
    let customer = {
      name: name ? name : data?.paymentMethodData?.info?.billingAddress?.name,
      email: email ? email : data?.email,
      phoneNumber: `${countryCode || '+1'}${data?.paymentMethodData?.info?.billingAddress?.phoneNumber.replace(/[\s\-]/g, '') || ""}`
    };
    const paylod = {
      paymentMethod,
      customerGid: getCustomerGidFromPayment(payment),
      customer: customer
    };
    await addInventoryOrderChargeById(paylod);
  };

  const chargeByApple = async (deviceData, amount, customerName, customerEmail,
    customerPhone, countryCode, stateCode, street, postalCode, city,
    cardNetwork, cardType, cardLast4) => {
    const paymentMethod = {
      applePayUS: {
        deviceData: deviceData,
        cardBrand: cardNetwork,
        cardFundingType: cardType,
        applePayDynamicLast4: cardLast4,
        cardLast4: cardLast4
      },
      type: "WALLET",
      subType: "APPLE_PAY_US",
      postalCode: postalCode,
      paymentMethodBillingAddress: {
        city: city,
        countryCode: countryCode,
        state: stateCode,
        street: street
      }
    }
    let customer = {
      email: customerEmail,
      name: customerName,
      phoneNumber: phoneNumber ? `${countryCode}${phoneNumber}` : null,
    }
    await addInventoryOrderChargeById({
      paymentMethod: paymentMethod,
      customerGid: getCustomerGidFromPayment(payment),
      customer: customer
    });

  }

  const getPaymentRequest = (currencyCode, items, label, amount) => {
    return {
      currencyCode: currencyCode,
      countryCode: 'US',
      lineItems: items,
      total: {
        label: label,
        amount: amount
      },
      supportedNetworks: ['masterCard', 'visa'],
      merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
      requiredShippingContactFields: [
        "postalAddress",
        "name",
        "phone",
        "email"
      ],
      requiredBillingContactFields: [
        "postalAddress",
        "email",
        "name",
        "phone"
      ]
    }
  }

  const getOnValidateMerchant = (resolve, reject, session, amount) => {
    return async (event) => {
      await performValidation(event.validationURL)
        .then((response) => {
          console.log(response.body)
          session.completeMerchantValidation(response.body);

        })
        .catch((err) => {
          console.log("Validate error ", JSON.stringify(err));
          session.abort();
        });
    }
  }

  const getOnPaymentAuthorized = (resolve, reject, session, currencyCode, amount) => {
    return (event) => {
      session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
      const payment = event.payment;
      console.log(event.payment, 'event.paymentevent.paymentevent.paymentevent.paymentevent.paymentevent.payment');
      const devicedata = `${payment.token.paymentData.data}&ectype=apple&ecsig=${payment.token.paymentData.signature}&eckey=${payment.token.paymentData.header.ephemeralPublicKey}&ectid=${payment.token.transactionIdentifier}&echash=&ecpublickeyhash=${payment.token.paymentData.header.publicKeyHash}`;
      const customerName = ((payment.billingContact.givenName) ? payment.billingContact.givenName : "") + (payment.billingContact.familyName ? payment.billingContact.familyName : "")
      const customerPhone = '+1' + payment.shippingContact.phoneNumber ? '+1' + payment.shippingContact.phoneNumber : ""
      const customerEmail = payment.shippingContact.emailAddress ? payment.shippingContact.emailAddress : ""
      const countryCode = payment.billingContact.countryCode ? payment.billingContact.countryCode : ""
      const stateCode = payment.billingContact.administrativeArea ? payment.billingContact.administrativeArea : ""
      const city = payment.billingContact.locality ? payment.billingContact.locality : ""
      const street = payment.billingContact.addressLines[0] ? payment.billingContact.addressLines[0] : ""
      const postalCode = payment.billingContact.postalCode ? payment.billingContact.postalCode : ""
      const cardNetwork = payment.token.paymentMethod.network ? payment.token.paymentMethod.network : ""
      const cardType = payment.token.paymentMethod.network ? payment.token.paymentMethod.network : ""
      const cardLast4 = payment.token.paymentMethod.displayName ? payment.token.paymentMethod.displayName : ""

      chargeByApple(devicedata, amount, customerName, customerEmail,
        customerPhone, countryCode, stateCode, street, postalCode, city,
        cardNetwork, cardType, cardLast4);
    }
  }


  const getOnCancel = (resolve, reject, session) => {
    return (event) => {
      console.log("Session cancelled!!!");
      resolve(2);
    }
  }

  const performApplePayPayment = (currencyCode, items, label, amount) => {
    return new Promise((resolve, reject) => {
      const session = new window.ApplePaySession(1, getPaymentRequest(currencyCode, items, label, amount));
      session.onvalidatemerchant = getOnValidateMerchant(resolve, reject, session, amount);
      session.onpaymentauthorized = getOnPaymentAuthorized(resolve, reject, session, currencyCode, amount);
      session.oncancel = getOnCancel(resolve, reject, session);
      session.begin();
    })
  }

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={null}
    >

      <>
        {
          transactionComplete ? (
            <Row type="flex" justify="space-between justify-content-center">
              <Col span={24} className="d-flex justify-content-center align-items-center mb-3">
                <CheckCircleOutlined style={{ color: 'green', fontSize: '36px' }} />
              </Col>
              <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
                <SpText fontSize='16px' color="#000000" fontWeight="400">Transaction Completed</SpText>
              </Col>
              <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
                <SpText fontSize='12px' color="#000000" fontWeight="400">You will be redirected automatically.</SpText>
              </Col>
            </Row>
          ) : (
            <>
              <Row type="flex" justify="space-between" className='mb-3'>
                <Col span={12} className="d-flex justify-content-start align-items-center mb-2">
                  {
                    selectPaymentMethod !== 'multiple' ? (
                      <img src={Back} onClick={() => setSelectPaymentMethod('multiple')} style={{ cursor: 'pointer' }} />
                    ) : (
                      <>&nbsp;</>
                    )
                  }
                </Col>
                <Col span={12} className="d-flex justify-content-end align-items-center mb-2">
                  <img src={CloseIcon} height='20' width='20' onClick={() => close()} style={{ cursor: 'pointer' }} />
                </Col>
              </Row>

              {
                selectPaymentMethod === 'multiple' && (
                  <>
                    <Row type="flex" justify="space-between">
                      <Col span={24} className="d-flex justify-content-center align-items-center mb-5">
                        <SpText fontSize="16px" color="#000000" fontWeight="500">Select a payment method</SpText>
                      </Col>
                    </Row>
                    <Row type="flex" justify="space-between" onClick={() => setSelectPaymentMethod('card')} style={{ padding: '7px 10px 0px 10px', border: '1px solid #858585', borderRadius: '10px', cursor: 'pointer' }} className='mb-3'>
                      <Col span={12} className="d-flex justify-content-start align-items-center mb-2">
                        <SpText fontSize="18px" color="#000000" fontWeight="600">Credit or debit card</SpText>
                      </Col>
                      <Col span={12} className="d-flex justify-content-end align-items-center mb-2">
                        <img src={CardPay} />
                      </Col>
                    </Row>
                    {
                      isApplePayEnabled && (
                        <Row type="flex" justify="space-between" onClick={() => setSelectPaymentMethod('applePay')} style={{ padding: '7px 10px 0px 10px', border: '1px solid #858585', borderRadius: '10px', cursor: 'pointer' }} className='mb-3'>
                          <Col span={12} className="d-flex justify-content-start align-items-center mb-2">
                            <SpText fontSize="18px" color="#000000" fontWeight="600">Apple Pay</SpText>
                          </Col>
                          <Col span={12} className="d-flex justify-content-end align-items-center mb-2">
                            <img src={ApplePay} />
                          </Col>
                        </Row>
                      )
                    }
                    {
                      isGooglePayEnabled && (
                        <Row type="flex" justify="space-between" onClick={() => setSelectPaymentMethod('googlePay')} style={{ padding: '7px 10px 0px 10px', border: '1px solid #858585', borderRadius: '10px', cursor: 'pointer' }} className='mb-3'>
                          <Col span={12} className="d-flex justify-content-start align-items-center mb-2">
                            <SpText fontSize="18px" color="#000000" fontWeight="600">Google Pay</SpText>
                          </Col>
                          <Col span={12} className="d-flex justify-content-end align-items-center mb-2">
                            <img src={GooglePay} />
                          </Col>
                        </Row>
                      )
                    }
                  </>
                )
              }

              {
                selectPaymentMethod === 'applePay' && (
                  <>
                    <Row type="flex" justify="space-between">
                      <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
                        <SpText fontSize="24px" color="#E3007B" fontWeight="600">PAY WITH APPLE PAY</SpText>
                      </Col>
                    </Row>
                    <Row type="flex" justify="space-between">
                      <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
                        {
                          isApplePayJsAvailable() && (
                            <Button
                              className='searchDateGradientBtn1 w-100'
                              style={{ height: '38px', fontSize: '18px', fontWeight: '500' }}
                              onClick={() => performApplePayPayment('USD', items, payment.account && payment.account.name ? payment.account.name : '', payment?.inventoryOrder?.total ? (payment?.inventoryOrder?.total / 100).toFixed(2) : null)}
                            >
                              Pay By Apple Pay {currency} {payment?.inventoryOrder?.total ? (payment?.inventoryOrder?.total / 100).toFixed(2) : null}
                            </Button>
                          )
                        }
                      </Col>
                    </Row>
                  </>
                )
              }

              {
                selectPaymentMethod === 'googlePay' && (
                  <>
                    <Row type="flex" justify="space-between">
                      <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
                        <SpText fontSize="24px" color="#E3007B" fontWeight="600">PAY WITH GOOGLE PAY</SpText>
                      </Col>
                    </Row>
                    <Row type="flex" justify="space-between">
                      <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
                        {
                          gpaySecretValues ? (
                            <GooglePayButton
                              environment={gpaySecretValues && gpaySecretValues.environment}
                              buttonColor="default"
                              buttonType="pay"
                              buttonRadius="4"
                              buttonLocale="en"
                              paymentRequest={{
                                apiVersion: 2,
                                apiVersionMinor: 0,
                                allowedPaymentMethods: [
                                  {
                                    type: gpaySecretValues && gpaySecretValues.paymentType,
                                    parameters: {
                                      allowedAuthMethods: gpaySecretValues && gpaySecretValues.allowedAuthMethods,
                                      allowedCardNetworks: gpaySecretValues && gpaySecretValues.allowedCardNetworks,
                                      billingAddressRequired: true,
                                      billingAddressParameters: { format: "FULL", phoneNumberRequired: true }
                                    },
                                    tokenizationSpecification: {
                                      type: gpaySecretValues && gpaySecretValues.acquirerType,
                                      parameters: {
                                        gateway: gpaySecretValues && gpaySecretValues.gateway,
                                        gatewayMerchantId: gpaySecretValues && gpaySecretValues.gatewayMerchantId
                                      }
                                    }
                                  }
                                ],
                                merchantInfo: {
                                  merchantId: gpaySecretValues && gpaySecretValues.googlePayMerchantId,
                                  merchantName: gpaySecretValues && gpaySecretValues.googlePayMerchantName
                                },
                                transactionInfo: {
                                  countryCode: payment.account.currency.countryAlpha2,
                                  currencyCode: payment.account.currency.name,
                                  totalPriceStatus: 'FINAL',
                                  totalPrice: payment?.inventoryOrder?.total ? (payment?.inventoryOrder?.total / 100).toFixed(2) : null,
                                  totalPriceLabel: 'Total'
                                },
                                emailRequired: true,
                                shippingAddressRequired: true
                              }}
                              onLoadPaymentData={paymentRequest => {
                                chargeByGooglePay(paymentRequest);
                              }}
                            />

                          ) : (
                            <GooglePayButton
                              buttonColor="default"
                              buttonType="pay"
                              environment="TEST"
                              buttonRadius="4"
                              buttonLocale="en"
                              paymentRequest={{
                                apiVersion: 2,
                                apiVersionMinor: 0,
                                allowedPaymentMethods: [
                                  {
                                    type: 'CARD',
                                    parameters: {
                                      allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                      allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"],
                                      billingAddressRequired: true,
                                      billingAddressParameters: { format: "FULL", phoneNumberRequired: true }
                                    },
                                    tokenizationSpecification: {
                                      type: 'PAYMENT_GATEWAY',
                                      parameters: {
                                        gateway: 'cardconnect',
                                        gatewayMerchantId: '820000003044',
                                      }
                                    }
                                  }
                                ],
                                merchantInfo: {
                                  merchantId: "820000003044",
                                  merchantName: "Demo Merchant"
                                },
                                transactionInfo: {
                                  countryCode: payment.account.currency.countryAlpha2,
                                  currencyCode: payment.account.currency.name,
                                  totalPriceStatus: 'FINAL',
                                  totalPrice: payment?.inventoryOrder?.total ? (payment?.inventoryOrder?.total / 100).toFixed(2) : null,
                                  totalPriceLabel: 'Total'
                                },
                                emailRequired: true,
                                shippingAddressRequired: true
                              }}
                              onLoadPaymentData={paymentRequest => {
                                chargeByGooglePay(paymentRequest);
                              }}
                            />
                          )
                        }
                      </Col>
                    </Row>
                  </>
                )
              }

              {
                selectPaymentMethod === 'card' && (
                  <>
                    {
                      <>
                        <Row type="flex" justify="space-between">
                          <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
                            <SpText fontSize="24px" color="#E3007B" fontWeight="600">PAY WITH CARD</SpText>
                          </Col>
                        </Row>
                        <Row type="flex" justify="space-between">
                          <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
                            <SpText fontSize="14px" color="#000000" fontWeight="500">Choose from Visa, Mastercard, Amex, and more</SpText>
                          </Col>
                        </Row>
                        <div className="px-4 mt-2">
                          <>
                            {
                              cardNumberRequired && (
                                <SpError>
                                  Required Card Information
                                </SpError>
                              )
                            }
                            <Row type="flex" justify="space-between mb-3">
                              <Col span={24} className='justify-content-start align-items-center'>
                                <div className="input-group">
                                  <svg {...getCardImageProps({ images })} style={{ left: '152%', right: '0px' }} />
                                  <label>
                                    <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>Card Number *</SpText>
                                  </label>
                                  <input {...getCardNumberProps()} style={{ width: '166%' }} />
                                </div>
                                <div>
                                  <SpError>
                                    {erroredInputs.cardNumber && erroredInputs.cardNumber}
                                  </SpError>
                                </div>
                              </Col>
                            </Row>
                            <Row type="flex" justify="space-between mb-3">
                              <Col span={12} className='justify-content-start align-items-center'>
                                <div className="input-group">
                                  <label>
                                    <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>Exp *</SpText>
                                  </label>
                                  <input {...getExpiryDateProps()} style={{ width: '166%' }} />
                                </div>
                                <div>
                                  <SpError>
                                    {erroredInputs.expiryDate && erroredInputs.expiryDate}
                                  </SpError>
                                </div>
                                {/* <div>
                <SpError>
                  {simpleValidator.current.message('expiry', expiry, 'required')}
                </SpError>
                </div>  */}
                              </Col>
                              <Col span={12} className='justify-content-start align-items-center'>
                                <div className="input-group">
                                  <label>
                                    <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>Cvv *</SpText>
                                  </label>
                                  <input {...getCVCProps()} style={{ width: '166%' }} type='password' />
                                </div>
                                <div>
                                  <SpError>
                                    {erroredInputs.cvc && erroredInputs.cvc}
                                  </SpError>
                                </div>
                                {/* <div>
                <SpError>
                  {simpleValidator.current.message('cvv', cvv, 'required')}
                </SpError>
                </div>                 */}
                              </Col>
                            </Row>
                            <Row type="flex" justify="space-between mb-3">
                              <Col span={24} className='justify-content-start align-items-center'>
                                <label>
                                  <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>NAME ON CARD *</SpText>
                                </label>
                                <Input type='text'
                                  placeholder='Cardholder name'
                                  value={cardholderName}
                                  style={{ height: '45px' }}
                                  onChange={(e) => { setCardholderName(e.currentTarget.value) }}
                                />
                                <SpError>
                                  {simpleValidator.current.message('cardholder name', cardholderName, 'required|cust')}
                                </SpError>
                              </Col>
                            </Row>
                            <hr />
                            <Row type="flex" justify="space-between mb-3">
                              <Col span={24} className='justify-content-start align-items-center'>
                                <label>
                                  <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>NAME *</SpText>
                                </label>
                                <Input type='text'
                                  placeholder='Name'
                                  value={name}
                                  name='Name'
                                  style={{ height: '45px' }}
                                  onChange={(e) => { setName(e.currentTarget.value) }}
                                />
                                <SpError>
                                  {simpleValidator.current.message('name', name, 'required|cust')}
                                </SpError>
                              </Col>
                            </Row>
                            <Row type="flex" justify="space-between mb-3">
                              <Col span={24} className='justify-content-start align-items-center'>
                                <label>
                                  <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>EMAIL *</SpText>
                                </label>
                                <Input type='text'
                                  placeholder='Email'
                                  value={email}
                                  style={{ height: '45px' }}
                                  onChange={(e) => { setEmail(e.currentTarget.value) }}
                                />
                                <SpError>
                                  {simpleValidator.current.message('email', email, 'required|email')}
                                </SpError>
                              </Col>
                            </Row>
                            <Row type="flex" justify="space-between mb-3">
                              <Col span={24} className='justify-content-start align-items-center'>
                                <label>
                                  <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>PHONE NUMBER *</SpText>
                                </label>
                                <div className="d-flex">
                                  <div
                                    style={{ width: isMobileView ? '30%' : '20%' }}
                                    onKeyPress={e => countryCodeValidation(e)}
                                  >
                                    <Select
                                      className="w-100"
                                      showSearch
                                      style={{ height: '45px' }}
                                      defaultValue={countryCode}
                                      onChange={onCountryCodeChange}
                                    >
                                      {COUNTRY_PHONE_CODE.map((item) => (
                                        <Option key={item} value={item}>
                                          {item}
                                        </Option>
                                      ))}
                                    </Select>
                                  </div>
                                  <div style={{ width: isMobileView ? '70%' : '80%' }}>
                                    <Input
                                      className="InputnumFormate"
                                      placeholder="Phone Number"
                                      value={phoneFormate}
                                      style={{ height: '45px' }}
                                      onChange={onPhoneNumberChange}
                                      maxLength={10}
                                      name='Phone number'
                                      onBlur={e => {
                                        if (e.currentTarget.value) {
                                          setPhone(e.currentTarget.value);
                                          const value = formatNumber(`${countryCode}${e.currentTarget.value}`, 'INTERNATIONAL');
                                          const formater = value.substr(value.indexOf(' ') + 1);
                                          setPhoneFormate(formater);
                                        }
                                      }}
                                    />
                                    <SpError>
                                      {simpleValidator.current.message('phone number', phoneNumber, `required|phoneNumValidation:${countryCode}${phoneNumber}`)}
                                    </SpError>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row type="flex" justify="space-between mb-3">
                                <Col span={24} className='justify-content-start align-items-center'>
                                  <label>
                                    <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>ZIP CODE *</SpText>
                                  </label>
                                  <Input
                                    placeholder='zip code'
                                    value={zipCode}
                                    style={{ height: '45px' }}
                                    onChange={(e) => setZipCode(e.currentTarget.value)}
                                  />
                                  <SpError>
                                    {simpleValidator.current.message('zip code', zipCode, 'required|postalcode')}
                                  </SpError>
                                </Col>
                              </Row>
                            {
                              collectBillingAddress && (
                                <>
                                  <hr />
                                  <Row type="flex" justify="space-between mb-3">
                                    <Col span={24} className='justify-content-start align-items-center'>
                                      <label>
                                        <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>BILLING ADDRESS</SpText>
                                      </label>
                                    </Col>
                                  </Row>
                                  <Row type="flex" justify="space-between mb-3">
                                    <Col span={24} className='justify-content-start align-items-center'>
                                      <label>
                                        <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>STREET *</SpText>
                                      </label>
                                      <Input type='text'
                                        placeholder='street'
                                        value={streetName}
                                        style={{ height: '45px' }}
                                        onChange={(e) => { setStreetName(e.currentTarget.value) }}
                                      />
                                      <SpError>
                                        {simpleValidator.current.message('street', streetName, 'required')}
                                      </SpError>
                                    </Col>
                                  </Row>
                                  <div className="pb-3">
                                    <div className="d-flex">
                                      <div className="w-50 mr-3">
                                        <label className="d-block"><SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>CITY *</SpText></label>
                                        <Input
                                          placeholder='city'
                                          value={cityName}
                                          style={{ height: '45px' }}
                                          onChange={(e) => setCityName(e.currentTarget.value)}
                                        />
                                        <SpError>
                                          {simpleValidator.current.message('city', cityName, 'required')}
                                        </SpError>
                                      </div>
                                      <div className="w-50">
                                        <label className="d-block"><SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>STATE *</SpText></label>
                                        <Select
                                          className="w-100"
                                          placeholder="State"
                                          showSearch
                                          optionFilterProp="children"
                                          value={stateName || 'Select state'}
                                          onChange={(e) => setStateName(e)}
                                        >
                                          {
                                            statesInCountry.map(s => (
                                              <Option
                                                key={s.id}
                                                value={s.id}
                                                className="text-capitalize"
                                              >
                                                {s.name}
                                              </Option>
                                            ))
                                          }
                                        </Select>
                                        <SpError>
                                          {simpleValidator.current.message('state', stateName, 'required')}
                                        </SpError>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="pb-3">
                                    <div className="d-flex">
                                      <div className="w-50 mr-3">
                                        <label className="d-block"><SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>ZIP CODE *</SpText></label>
                                        <Input
                                          placeholder='zip code'
                                          value={zipCode}
                                          style={{ height: '45px' }}
                                          onChange={(e) => setZipCode(e.currentTarget.value)}
                                        />
                                        <SpError>
                                          {simpleValidator.current.message('zip code', zipCode, 'required|postalcode')}
                                        </SpError>
                                      </div>
                                      <div className="w-50">
                                        <label className="d-block"><SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>COUNTRY *</SpText></label>
                                        <Select
                                          defaultValue={countryName}
                                          style={{ width: '100%' }}
                                          disabled
                                        >
                                          {COUNTRY_CODES.map((item) => (
                                            <Option key={item.ID} value={item.ALPHA2}>
                                              {item.NAME}
                                            </Option>
                                          ))}
                                        </Select>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )
                            }

                            {
                              collectShippingAddress && (
                                <>
                                  <hr />
                                  <Row type="flex" justify="space-between mb-3">
                                    <Col span={24} className='justify-content-start align-items-center'>
                                      <label>
                                        <Checkbox
                                          className="mr-2"
                                          checked={addressSame}
                                          onChange={({ target: { checked } }) => {
                                            if (checked) {
                                              setStreetName1(streetName);
                                              setCityName1(cityName);
                                              setStateName1(stateName);
                                              setZipCode1(zipCode);
                                              setAddressSame(true);
                                            } else if (!checked) {
                                              setStreetName1('');
                                              setCityName1('');
                                              setStateName1('');
                                              setZipCode1('');
                                              setAddressSame(false);
                                            }
                                          }}
                                        /> &nbsp;&nbsp;<SpText fontSize="14px" color='#5C5C5C' fontWeight='400'>Use Billing Address For Shipping</SpText>
                                      </label>
                                    </Col>
                                  </Row>
                                  <Row type="flex" justify="space-between mb-3">
                                    <Col span={24} className='justify-content-start align-items-center'>
                                      <label>
                                        <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>SHIPPING ADDRESS</SpText>
                                      </label>
                                    </Col>
                                  </Row>
                                  <Row type="flex" justify="space-between mb-3">
                                    <Col span={24} className='justify-content-start align-items-center'>
                                      <label>
                                        <SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>STREET *</SpText>
                                      </label>
                                      <Input type='text'
                                        placeholder='street'
                                        value={streetName1}
                                        style={{ height: '45px' }}
                                        disabled={addressSame}
                                        onChange={(e) => { setStreetName1(e.currentTarget.value) }}
                                      />
                                      <SpError>
                                        {simpleValidator.current.message('street', streetName1, 'required')}
                                      </SpError>
                                    </Col>
                                  </Row>
                                  <div className="pb-3">
                                    <div className="d-flex">
                                      <div className="w-50 mr-3">
                                        <label className="d-block"><SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>CITY *</SpText></label>
                                        <Input
                                          placeholder='city'
                                          value={cityName1}
                                          style={{ height: '45px' }}
                                          disabled={addressSame}
                                          onChange={(e) => setCityName1(e.currentTarget.value)}
                                        />
                                        <SpError>
                                          {simpleValidator.current.message('city', cityName, 'required')}
                                        </SpError>
                                      </div>
                                      <div className="w-50">
                                        <label className="d-block"><SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>STATE *</SpText></label>
                                        <Select
                                          className="w-100"
                                          placeholder="State"
                                          showSearch
                                          optionFilterProp="children"
                                          value={stateName1 || 'Select state'}
                                          disabled={addressSame}
                                          onChange={(e) => setStateName1(e)}
                                        >
                                          {
                                            statesInCountry.map(s => (
                                              <Option
                                                key={s.id}
                                                value={s.id}
                                                className="text-capitalize"
                                              >
                                                {s.name}
                                              </Option>
                                            ))
                                          }
                                        </Select>
                                        <SpError>
                                          {simpleValidator.current.message('state', stateName1, 'required')}
                                        </SpError>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="pb-3">
                                    <div className="d-flex">
                                      <div className="w-50 mr-3">
                                        <label className="d-block"><SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>ZIP CODE *</SpText></label>
                                        <Input
                                          placeholder='zip code'
                                          value={zipCode1}
                                          style={{ height: '45px' }}
                                          disabled={addressSame}
                                          onChange={(e) => setZipCode1(e.currentTarget.value)}
                                        />
                                        <SpError>
                                          {simpleValidator.current.message('zip code', zipCode1, 'required|postalcode')}
                                        </SpError>
                                      </div>
                                      <div className="w-50">
                                        <label className="d-block"><SpText fontSize="16px" color='#5C5C5C' fontWeight='600'>COUNTRY *</SpText></label>
                                        <Select
                                          defaultValue={countryName}
                                          style={{ width: '100%' }}
                                          disabled
                                        >
                                          {COUNTRY_CODES.map((item) => (
                                            <Option key={item.ID} value={item.ALPHA2}>
                                              {item.NAME}
                                            </Option>
                                          ))}
                                        </Select>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )
                            }

                            {/* <Row type="flex" justify="space-between mb-3">
                              <Col span={24} className='justify-content-start align-items-center'>
                                <label>
                                  <Checkbox
                                    className="mr-2"
                                    checked={shouldWhatsAppNotify}
                                    onChange={({ target: { checked } }) => {
                                      if (checked) {
                                        setShouldWhatsAppNotify(true);
                                      } else if (!checked) {
                                        setShouldWhatsAppNotify(false);
                                      }
                                    }}
                                  /> &nbsp;&nbsp;<SpText fontSize="14px" color='#5C5C5C' fontWeight='400'>Notify on whatsapp</SpText>
                                </label>
                              </Col>
                            </Row> */}

                            <Row className='mt-3'>
                              {
                                errMsg && (
                                  <SpError>
                                    {errMsg}
                                  </SpError>
                                )
                              }
                            </Row>

                            <Row className='mt-3'>
                              <Col span={24}>
                                <Button className='searchDateGradientBtn w-100' style={{ height: '38px', fontSize: '18px', fontWeight: '500' }} onClick={(e) => validate(e)} disabled={isDisabled}>
                                  {
                                    isDisabled ? (
                                      <>
                                        <Spin />&nbsp;&nbsp;
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  }
                                  PAY {currency} {payment?.inventoryOrder?.total ? (payment?.inventoryOrder?.total / 100).toFixed(2) : null}
                                </Button>
                              </Col>
                            </Row>
                          </>
                        </div>
                      </>
                    }
                  </>
                )
              }
            </>
          )
        }
      </>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isMobileView: state.cartInfo.isMobileView,
  inVentData: state.cartInfo.inVentData,
});

const mapDispatchToProps = (dispatch) => ({
  getItemsInfo: param => dispatch(cartActions.getItemsInfo({
    payload: param,
  })),
  getUserInfo: param => dispatch(cartActions.getUserInfo({
    payload: param,
  })),
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  getShopInfo: param => dispatch(cartActions.getShopInfo({
    payload: param,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(PaymentPortal);
